// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"ae5ad705","618":"5abb4a44","707":"250f1a83","717":"8bada988","748":"646ea7d7","952":"05fa9b49"}[chunkId] + ".chunk.css";
};